<template>
  <div class="c-payment-details p-2 p-md-0">
    <h2 class="fs-18 w-bold mb-3 darks">{{title}}</h2>
    <div class="c-payment-details__cards mb-3">
      <div id="slider-banks" class="c-slider" :class="classSwiperContainer">
        <div :class="classSwiperWrapper">
          <div
            v-for="entity of entities.list"
            :key="entity.id"
            class="d-flex justify-content-center align-items-center"
            :class="classSwiperSlide">
            <figure>
              <img class="h-100 of--contain" :src="`${src}/checkout/${entities.dir}/${entity}.png`">
            </figure>
          </div>
        </div>
        <div
          v-if="entities.dir != 'cards'"
          class="c-slider__pagination swiper-pagination mt-2">
        </div>
      </div>
    </div>
    <ul class="c-payment-details__items ul-reset">
      <li class="c-payment-details__item d-flex">
        <div>
          <span class="c-icon">
            <i class="iconf-warranty d-flex align-items-center fs-21 mr-2"></i>
          </span>
        </div>
        <p class="mb-0"><span class="w-sbold">
          15 días de garantía.</span> ¡Si no lo Amas te regresamos tu dinero!
        </p>
      </li>
      <li class="c-payment-details__item d-flex">
        <div>
          <span class="c-icon">
            <i class="iconf-hand d-flex align-items-center fs-21 mr-2"></i>
          </span>
        </div>
        <p v-if="product.type == 'subscription'" class="mb-0">
          <span class="w-sbold">Acceso ilimitado</span> a todos nuestros cursos
        </p>
        <p v-else class="mb-0">
          <span class="w-sbold">Acceso al curso de por vida.</span> ¡Aprender a tu ritmo!
        </p>
      </li>
      <li class="c-payment-details__item d-flex">
        <div>
          <span class="c-icon">
            <i class="iconf-lock-alt d-flex align-items-center fs-21 mr-2"></i>
          </span>
        </div>
        <p class="mb-0">
          <span class="w-sbold">Privacidad.</span>  Tu información está 100% segura
        </p>
      </li>
      <li class="c-payment-details__item d-flex">
        <div>
          <span class="c-icon">
            <i class="iconf-shield d-flex align-items-center fs-21 mr-2"></i>
          </span>
        </div>
        <p class="mb-0">
          <span class="w-sbold">Compra segura.</span> Ambiente seguro y autenticado
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
/* eslint-disable */
import Swiper from 'swiper';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      arcux: {...window.arcux},

      entities: {
        dir: 'cards',
        list: [],
      },
      cards: [
        'american',
        'cencosud',
        'cmr',
        'dinners',
        'mastercard',
        'oh',
        'ripley',
        'union',
        'visa',
      ],
      banks: {
        pe: [
          'bcp',
          'interbank',
          'bbva',
          'scotiabank',
          'banbif',
          'banco_pichincha',
          'banco_nacion',
          'western',
          'caja_arequipa',
          'moneygram',
          'disashop',
          'red_digital',
          'tambo',
          'kasnet',
          'caja_sullana',
          'banco_azteca',
          'caja_trujillo',
          'caja_andes',
          'caja_santa',
          'raiz',
          'caja_paita',
        ],
      },

      sliderBanks: null,
    }
  },
  computed: {
    ...mapState({
      country: (state) => state.checkout.country,
      product: (state) => state.checkout.product,
      paymentMethod: (state) => state.checkout.paymentMethod,
    }),

    'src': function() {
      return `${arcux.site}/app/themes/arcuxt/dist/images`;
    },
    'title': function() {
      return (this.paymentMethod == 'cash' && this.country.code == 'pe') ? 'Puedes realizar tus pagos mediante:' : 'Aceptamos:';
    },
    'classSwiperContainer': function() {
      return (this.entities.dir != 'cards') ? 'swiper-container' : '';
    },
    'classSwiperWrapper': function() {
      return (this.entities.dir != 'cards') ? 'swiper-wrapper' : ['d-flex', 'flex-wrap'];
    },
    'classSwiperSlide': function() {
      return (this.entities.dir != 'cards') ? 'swiper-slide' : '';
    },
  },
  watch: {
    'paymentMethod': function() {
      this.setEntities();
    },
    'country': function() {
      this.setEntities();
    },
  },
  mounted() {
    this.setEntities();
  },
  methods: {
    initBanksSlider: function() {
      window.setTimeout(() => {
        if (this.sliderBanks) {
          this.sliderBanks.update();
        } else {
          this.sliderBanks = new Swiper('#slider-banks', {
            slidesPerView: 2,
            spaceBetween: 10,
            speed: 2000,
            loop: false,
            autoplay: true,

            pagination: {
              el: '#slider-banks .swiper-pagination',
              type: 'bullets',
              clickable: true,
            },

            breakpoints: {
              320: {
                slidesPerView: 3,
                slidesPerGroup: 3,
              },
              480: {
                slidesPerView: 3,
                slidesPerGroup: 3,
              },
              640: {
                slidesPerView: 5,
                slidesPerGroup: 5,
              },
              1024: {
                slidesPerView: 4,
                slidesPerGroup: 4,
              },
              1140: {
                slidesPerView: 5,
                slidesPerGroup: 5,
              },
            },
          })
        }
      }, 1000)
    },
    setEntities: function() {
      if (this.method == 'cash' && ['pe'].includes(this.country.code)) {
        this.entities.dir   = `banks/${this.country.code}`;
        this.entities.list  = this.banks[this.country.code];

        this.initBanksSlider();
      } else {
        this.entities.dir   = 'cards';
        this.entities.list  = this.cards;

        if (this.sliderBanks) {
          this.sliderBanks.destroy();

          this.sliderBanks = null;
        }
      }
    },
  },
}
</script>
